import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SLATE = [15, 23, 42];
const BLUE = [37, 99, 235];
const MUTED = [100, 116, 139];

const money = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(+v || 0);

export function generateQuotePDF({ reference, createdAt, validUntil, location, inputs, breakdown }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const M = 40;
  const fmt = (d) => new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const date = fmt(createdAt || Date.now());
  const validText = validUntil ? fmt(validUntil) : null;

  // Header band
  doc.setFillColor(...SLATE);
  doc.rect(0, 0, W, 92, "F");
  doc.setFillColor(...BLUE);
  doc.rect(0, 92, W, 4, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("GloGrid", M, 44);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(170, 190, 220);
  doc.text("Global Cost, Local Reach", M, 60);
  doc.text("VMI Warehousing & Fulfillment", M, 73);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.setTextColor(255, 255, 255);
  doc.text("SERVICE QUOTATION", W - M, 44, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(170, 190, 220);
  doc.text(`Ref: ${reference}`, W - M, 60, { align: "right" });
  doc.text(`Date: ${date}`, W - M, 73, { align: "right" });
  if (validText) doc.text(`Valid until: ${validText}`, W - M, 84, { align: "right" });

  let y = 128;
  doc.setTextColor(...MUTED);
  doc.setFontSize(8);
  doc.text("PREPARED FOR", M, y);
  doc.text("SERVICE LOCATION", W / 2, y);
  doc.setTextColor(...SLATE);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(inputs.companyName || "Prospective Client", M, y + 16);
  doc.text(location.label, W / 2, y + 16);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...MUTED);
  if (inputs.contactName) doc.text(inputs.contactName, M, y + 30);
  if (inputs.contactEmail) doc.text(inputs.contactEmail, M, y + 42);
  doc.text(
    `Applied labor rate: ${money(location.rates.labor)}/hr`,
    W / 2,
    y + 30
  );

  const rows = [
    ["Storage of goods", `${inputs.storageSqft} sqft x ${inputs.storageMonths} mo @ ${money(location.rates.storage)}/sqft`, money(breakdown.storage)],
    ["Inbound receiving", `${inputs.inboundPallets} pallets @ ${money(location.rates.inbound)}/pallet`, money(breakdown.inbound)],
    ["Handling / Picking (labor)", `${inputs.monthlyOrders} orders x ${inputs.linesPerOrder} lines`, money(breakdown.pickLabor)],
    ["Repacking (labor)", `${inputs.repackUnits} units`, money(breakdown.repackLabor)],
    ["Outbound / Shipping", `${inputs.outboundPallets} pallets @ ${money(location.rates.outbound)}/pallet`, money(breakdown.outbound)],
  ];

  autoTable(doc, {
    startY: y + 62,
    margin: { left: M, right: M },
    head: [["Service Component", "Basis", "Monthly Cost"]],
    body: rows,
    theme: "grid",
    styles: { font: "helvetica", fontSize: 9, cellPadding: 8, lineColor: [226, 232, 240], textColor: SLATE },
    headStyles: { fillColor: SLATE, textColor: [255, 255, 255], fontStyle: "bold", halign: "left" },
    columnStyles: { 2: { halign: "right", fontStyle: "bold" } },
  });

  let ty = doc.lastAutoTable.finalY + 18;
  const boxX = W / 2;
  const line = (label, val, bold, color) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(bold ? 12 : 10);
    doc.setTextColor(...(color || SLATE));
    doc.text(label, boxX, ty);
    doc.text(money(val), W - M, ty, { align: "right" });
    ty += bold ? 22 : 18;
  };
  line("Subtotal", breakdown.subtotal, false);
  line(`G&A / Project Management (${inputs.gaPercent}%)`, breakdown.ga, false);
  doc.setDrawColor(...SLATE);
  doc.line(boxX, ty - 6, W - M, ty - 6);
  ty += 6;
  line("ESTIMATED MONTHLY TOTAL", breakdown.total, true, BLUE);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(...MUTED);
  const disclaimer =
    "This quotation is an estimate generated from regional rate benchmarks and the volumes provided. " +
    "Final pricing is subject to a signed service agreement, facility availability and inbound inspection. " +
    (validText ? `Rates shown are illustrative and valid until ${validText}.` : "Rates shown are illustrative and valid for 30 days from the date above.");
  doc.text(doc.splitTextToSize(disclaimer, W - M * 2), M, doc.internal.pageSize.getHeight() - 60);
  doc.setTextColor(...SLATE);
  doc.text("GloGrid  |  connect@glogrid.com  |  www.glogrid.com", M, doc.internal.pageSize.getHeight() - 30);

  doc.save(`${reference}.pdf`);
}
